export enum PAYMENT_STATUS {
  // SUCCESS is not an actual PaymentStatus, but as present in rhea-client,
  // it is used in some UI elements to determine states.
  SUCCESS = "SUCCESS",

  CAPTURE = "CAPTURE",
  SETTLEMENT = "SETTLEMENT",
  AUTHORIZE = "AUTHORIZE",
  REFUND = "REFUND",
  CHARGEBACK = "CHARGEBACK",
  PARTIAL_CHARGEBACK = "PARTIAL_CHARGEBACK",
  PARTIAL_REFUND = "PARTIAL_REFUND",
  PARTIAL_SETTLEMENT = "PARTIAL_SETTLEMENT",
  CANCEL = "CANCEL",
  CHALLENGE = "CHALLENGE",
  DENY = "DENY",
  PENDING = "PENDING",
  EXPIRE = "EXPIRE",
  FAILURE = "FAILURE",
}

export enum PAYMENT_TYPE {
  CREDIT_CARD = "CREDIT_CARD",
  GOPAY = "GOPAY",
  QRIS = "QRIS",
  CASH = "CASH",
  OFFLINE_OVO = "OFFLINE_OVO",
  OFFLINE_TELKOMSEL_CASH = "OFFLINE_TELKOMSEL_CASH",
  OFFLINE_CREDIT_CARD = "OFFLINE_CREDIT_CARD",
  DEBIT_CARD = "DEBIT_CARD",
}

export const paymentTypeHuman = (paymentType: string = "") => {
  switch (paymentType.toUpperCase()) {
    case PAYMENT_TYPE.CREDIT_CARD:
    case "CREDIT":
      return "Credit Card";
    case PAYMENT_TYPE.GOPAY:
      return "GoPay";
    case PAYMENT_TYPE.CASH:
      return "Cash";
    case PAYMENT_TYPE.OFFLINE_OVO:
      return "OVO";
    case PAYMENT_TYPE.OFFLINE_TELKOMSEL_CASH:
      return "Link Aja";
    case PAYMENT_TYPE.OFFLINE_CREDIT_CARD:
      return "Offline Debit / Credit Card";
    case PAYMENT_TYPE.DEBIT_CARD:
    case "DEBIT":
      return "Debit Card";
  }
  return paymentType.toUpperCase();
};
